var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "485px",
    height: "495px",
    viewBox: "0 0 485 495",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rocket_Background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.51246203e-15%",
    y1: "7.48099499e-14%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495791",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387795",
    offset: "65.2875189%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB19C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rocket_Background",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 0,
    y: 0,
    width: 439,
    height: 439,
    rx: 63
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(110.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.3664509,221.543792 C122.041729,221.543792 149.340937,248.825996 149.340937,282.4803 C149.340937,316.134604 108.043723,369.004163 14.6866849,357.379061 C-2.9987452,254.27729 54.6911723,221.543792 88.3664509,221.543792 Z M83.2212529,266.496953 C71.4755526,266.496953 51.353715,277.914167 57.5222687,313.87534 C90.0845471,317.930094 104.488725,299.489563 104.488725,287.751179 C104.488725,276.012794 94.9669533,266.496953 83.2212529,266.496953 Z",
    id: "Combined-Shape",
    fill: "#6CE8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.322579,275.529375 L170.322579,348.801097 C170.322579,356.533083 176.590593,362.801097 184.322579,362.801097 C186.771635,362.801097 189.177845,362.158652 191.300967,360.937904 L260.718928,321.024157 C274.060568,313.353018 282.285307,299.136613 282.285307,283.74682 L282.285307,220.361763 L282.285307,220.361763 L170.322579,275.529375 Z",
    id: "Path-8",
    fill: "#6CE8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4201872,127.670239 L20.4201872,200.987666 C20.4201872,208.719652 26.6882007,214.987666 34.4201872,214.987666 C36.8717996,214.987666 39.2804308,214.343879 41.4051115,213.120713 L110.766875,173.189551 C124.097209,165.515356 132.313179,151.30528 132.313179,135.923763 L132.313179,72.4682442 L132.313179,72.4682442 L20.4201872,127.670239 Z",
    id: "Path-8",
    fill: "#6CE8C6",
    transform: "translate(76.366683, 148.834928) scale(-1, 1) rotate(-90.000000) translate(-76.366683, -148.834928) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.967151,10.9972382 C418.962952,160.386013 240.724649,260.200432 170.322579,276.528335 C172.182873,261.0817 145.0597,204.692908 95.9834976,204.692908 C111.293506,138.765994 203.668912,-46.7854295 364.967151,10.9972382 Z M282.285307,63.7082464 C266.827802,63.7082464 254.297018,76.2312253 254.297018,91.6791026 C254.297018,107.12698 266.827802,119.649959 282.285307,119.649959 C297.742812,119.649959 310.273595,107.12698 310.273595,91.6791026 C310.273595,76.2312253 297.742812,63.7082464 282.285307,63.7082464 Z",
    id: "Combined-Shape",
    fill: "#08D6A1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketBackground);
export default __webpack_public_path__ + "static/media/Rocket_Background.2577bb720f929be9c6e647c9d8c83534.svg";
export { ForwardRef as ReactComponent };